var _g, _circle, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup47215(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_33_590)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 88,
    r: 88,
    fill: "#9B99FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33_590",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 176,
    height: 176
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 88,
    r: 88,
    fill: "#C3EEFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33_590)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_33_590)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.2724,
    cy: 44.6914,
    rx: 103.51,
    ry: 85.6398,
    fill: "#B3EDFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_33_590)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.957,
    cy: -6.88811,
    rx: 103.51,
    ry: 85.6398,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_33_590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.4722 4.52792C27.3648 24.6085 14.3715 59.651 14.3715 124.224C-21.3997 124.224 -46.067 42.6912 -46.067 4.52792C-46.067 -33.6353 -17.0686 -64.5728 18.7026 -64.5728C54.4739 -64.5728 83.4722 -33.6353 83.4722 4.52792Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_33_590",
    x: -5.5123,
    y: -4.13423,
    width: 181.512,
    height: 180.134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.5123,
    dy: -4.13423
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.57942
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_33_590"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_33_590",
    x: -66.7383,
    y: -97.4496,
    width: 320.021,
    height: 284.282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.2506,
    result: "effect1_foregroundBlur_33_590"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_33_590",
    x: 15.9464,
    y: -149.029,
    width: 320.021,
    height: 284.282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.2506,
    result: "effect1_foregroundBlur_33_590"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_33_590",
    x: -72.2504,
    y: -90.7562,
    width: 181.906,
    height: 241.163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.0917,
    result: "effect1_foregroundBlur_33_590"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup47215);
export default __webpack_public_path__ + "static/media/Group 47215.9ac0f2aeaf8ae3774fed22b1513bfe9f.svg";
export { ForwardRef as ReactComponent };